// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-upload-status {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 4000;
  display: grid;
  gap: 8px;
  width: min(320px, calc(100vw - 32px));
  pointer-events: none;
}

.global-upload-status-item {
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  text-align: left;
}

.global-upload-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.global-upload-status-name {
  min-width: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.global-upload-status-meta {
  flex-shrink: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.global-upload-status-item progress {
  display: block;
  width: 100%;
  height: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/UploadStatus.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,QAAQ;EACR,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb","sourcesContent":[".global-upload-status {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 4000;\n  display: grid;\n  gap: 8px;\n  width: min(320px, calc(100vw - 32px));\n  pointer-events: none;\n}\n\n.global-upload-status-item {\n  padding: 12px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  text-align: left;\n}\n\n.global-upload-status-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.global-upload-status-name {\n  min-width: 0;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.global-upload-status-meta {\n  flex-shrink: 0;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.global-upload-status-item progress {\n  display: block;\n  width: 100%;\n  height: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
